<script lang="ts" setup></script>

<template>
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.0114 5.53647C9.68859 5.93621 6.30401 9.57285 6.30401 14C6.30401 14.95 6.45985 15.8636 6.74738 16.7166C6.85558 17.0376 6.90968 17.1981 6.91943 17.3214C6.92907 17.4432 6.92179 17.5286 6.89166 17.6469C6.86115 17.7668 6.7938 17.8915 6.6591 18.1408L5.02344 21.1684C4.79013 21.6002 4.67348 21.8161 4.69959 21.9828C4.72233 22.1279 4.80775 22.2557 4.93318 22.3322C5.07718 22.4201 5.32131 22.3948 5.80955 22.3444L10.9306 21.815C11.0856 21.799 11.1632 21.791 11.2339 21.7937C11.3034 21.7963 11.3525 21.8029 11.4202 21.8185C11.4892 21.8344 11.5758 21.8678 11.7492 21.9345C12.6972 22.2998 13.7272 22.5 14.804 22.5C19.2348 22.5 22.8738 19.1098 23.2685 14.7819M22.4253 6.37868C23.5969 7.55025 23.5969 9.44975 22.4253 10.6213C21.2538 11.7929 19.3543 11.7929 18.1827 10.6213C17.0111 9.44975 17.0111 7.55025 18.1827 6.37868C19.3543 5.20711 21.2538 5.20711 22.4253 6.37868Z"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<style scoped lang="scss">
	svg {
		width: 28px;
		height: 28px;
	}
</style>
